import { render } from "./StModal.vue?vue&type=template&id=960a8da6"
import script from "./StModal.vue?vue&type=script&lang=js"
export * from "./StModal.vue?vue&type=script&lang=js"

import "./StModal.vue?vue&type=style&index=0&id=960a8da6&lang=scss"

import exportComponent from "/Users/ondaa/workspace/schoolmom_qna_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__